import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";
import { PlaceholderImage } from "@components/atoms";
import { useNetworkStatus } from "@hooks";
import NoPhoto from "images/no-photo.svg";
export var CachedImage = function CachedImage(_ref) {
  var url = _ref.url,
      url2x = _ref.url2x,
      alt = _ref.alt,
      children = _ref.children,
      _ref$defaultImage = _ref.defaultImage,
      defaultImage = _ref$defaultImage === void 0 ? NoPhoto : _ref$defaultImage,
      props = _objectWithoutProperties(_ref, ["url", "url2x", "alt", "children", "defaultImage"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isUnavailable = _React$useState2[0],
      setUnavailable = _React$useState2[1];

  var _useNetworkStatus = useNetworkStatus(),
      online = _useNetworkStatus.online;

  React.useEffect(function () {
    updateAvailability();
  }, [online]);

  function updateAvailability() {
    return _updateAvailability.apply(this, arguments);
  }

  function _updateAvailability() {
    _updateAvailability = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _isUnavailable, match, match2x;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _isUnavailable = false;

              if (!("caches" in window)) {
                _context.next = 11;
                break;
              }

              if (online) {
                _context.next = 11;
                break;
              }

              _context.next = 5;
              return window.caches.match(url);

            case 5:
              match = _context.sent;

              if (!url2x) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return window.caches.match(url2x);

            case 9:
              match2x = _context.sent;

            case 10:
              if (!match && !match2x) {
                _isUnavailable = true;
              }

            case 11:
              if (isUnavailable !== _isUnavailable) {
                setUnavailable(_isUnavailable);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _updateAvailability.apply(this, arguments);
  }

  if (!url || isUnavailable) {
    return children || React.createElement(PlaceholderImage, {
      alt: alt
    });
  }

  return React.createElement("img", _extends({}, props, {
    src: url,
    srcSet: url2x ? "".concat(url, " 1x, ").concat(url2x, " 2x") : "".concat(url, " 1x"),
    alt: alt // navigator.onLine is not always accurate
    ,
    onError: function onError() {
      return setUnavailable(true);
    }
  }));
};